import React, { useEffect, useState } from "react";
import "./style/feedbackForm.css";
import axios from "axios";
import { apiUrl } from "../config/api";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function FeedbackForm() {
  const [company, setCompany] = useState([]);
  const { lang } = useParams();
  const { t, i18n } = useTranslation("feedback");

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const result = await axios.post(
          apiUrl("/api/company/list"),
          {},
          { headers: { "Content-Type": "application/json" } }
        );
        if (result.status === 200) {
          setCompany(result.data.result);
        }
      } catch (error) {
        console.error("ERROR", error);
        toast.error(`${t("form.fetchError")}: ${error.message}`, {
          position: "top-right",
          autoClose: 5000,
          style: { fontSize: "14px" },
        });
      }
    };
    fetchCompanies();
  }, [t]);

  const onSubmit = async (data) => {
    try {
      await axios.post(
        apiUrl("/api/feedback/submit"),
        {
          jsonrpc: "2.0",
          method: "call",
          params: {
            lastname: data.lastName,
            firstname: data.firstName,
            email: data.email,
            phone: data.phone,
            company_id: parseInt(data.company_id, 10),
            status: data.type,
            description: data.description,
          },
        },
        { headers: { "Content-Type": "application/json" } }
      );

      toast.success(t("form.success"), {
        position: "top-right",
        autoClose: 5000,
        style: { fontSize: "14px" }, // Text size багасгах
      });
      reset();
    } catch (error) {
      toast.error(`${t("form.submitError")}: ${error.message}`, {
        position: "top-right",
        autoClose: 5000,
        style: { fontSize: "14px" },
      });
    }
  };

  return (
    <div className="form-container">
      <h2 className="form-title">{t("form.title")}</h2>

      <form onSubmit={handleSubmit(onSubmit)} className="form">
        <div className="form-row">
          <div className="form-group">
            <input
              type="text"
              placeholder={t("form.firstName")}
              {...register("firstName", { required: t("error.required") })}
              className="form-input"
            />
            {errors.firstName && (
              <p className="error">{errors.firstName.message}</p>
            )}
          </div>

          <div className="form-group">
            <input
              type="text"
              placeholder={t("form.lastName")}
              {...register("lastName", { required: t("error.required") })}
              className="form-input"
            />
            {errors.lastName && (
              <p className="error">{errors.lastName.message}</p>
            )}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <input
              type="email"
              placeholder={t("form.email")}
              {...register("email", {
                required: t("error.required"),
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: t("error.invalidEmail"),
                },
              })}
              className="form-input"
            />
            {errors.email && <p className="error">{errors.email.message}</p>}
          </div>

          <div className="form-group">
            <input
              type="tel"
              placeholder={t("form.phone")}
              {...register("phone", {
                required: t("error.required"),
                pattern: {
                  value: /^[0-9]{8}$/,
                  message: t("error.invalidPhone"),
                },
              })}
              className="form-input"
            />
            {errors.phone && <p className="error">{errors.phone.message}</p>}
          </div>
        </div>

        <div className="form-group">
          <label className="label">{t("form.company")} *</label>
          <select
            {...register("company_id", {
              required: t("error.required"),
              validate: (value) =>
                parseInt(value, 10) > 0 ? true : t("error.invalidCompany"),
            })}
            className="form-input"
          >
            <option value="">{t("form.company")}</option>
            {company.map((e) => (
              <option key={e.id} value={e.id}>
                {e.name}
              </option>
            ))}
          </select>
          {errors.company_id && (
            <p className="error">{errors.company_id.message}</p>
          )}
        </div>

        <div className="form-group">
          <label className="label">{t("form.type")} *</label>
          <select
            {...register("type", { required: t("error.required") })}
            className="form-input"
          >
            <option value="">{t("form.type")}</option>
            <option value="sanal_huselt">{t("option.feedback")}</option>
            <option value="gomdol">{t("option.complaint")}</option>
            <option value="urgudul">{t("option.request")}</option>
          </select>
          {errors.type && <p className="error">{errors.type.message}</p>}
        </div>

        <div className="form-group">
          <textarea
            placeholder={t("form.description")}
            {...register("description", {
              required: t("error.required"),
              minLength: { value: 10, message: t("error.minLength") },
            })}
            rows="5"
            className="textarea"
          />
          {errors.description && (
            <p className="error">{errors.description.message}</p>
          )}
        </div>

        <button type="submit" className="submit-btn">
          {t("form.submit")}
        </button>
      </form>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
